import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../api/session";

/**
 * Route guard for pages that need any signed-in user, such as the User
 * Dashboard. Anonymous visitors are sent to the normal sign-in page.
 */
export default function RequireAuth({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/build/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
